import React from 'react';
import { Form } from 'react-bootstrap';
import { FormRadio } from '~/components/FormControl';

function MiscellaneousDetail() {
    return (
        <Form.Row>
            <FormRadio
                name="miscellaneousDetail.isDamagePlayer"
                tooltip="To state that the card deals damage to the player."
            />
            <FormRadio
                name="miscellaneousDetail.isDamageAggressor"
                tooltip="To state that the card deals damage to the aggressor."
            />
            <FormRadio
                name="miscellaneousDetail.isDamageWinner"
                tooltip="To state that the card deals damage to the winner."
            />
            <FormRadio
                name="miscellaneousDetail.isEvenCondition"
                tooltip="To state that the card is transformable."
            />
        </Form.Row>
    );
}

export default MiscellaneousDetail;
